module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av178-6d1707d8ece45b8e66f2e7e8a805e6b5.jpg";